export const questionsList = {
  0: {
    ques: "Who was the first President of India?",
    option1: "Mahatma Gandhi",
    option2: "Modi",
    option3: "Rajendra Prasad",
    option4: "Jawarhar Lal Nehru",
    correct_option: 3,
  },
  1: {
    ques: "Which country's national game is cricket?",
    option1: "Australia",
    option2: "England",
    option3: "South-Africa",
    option4: "India",
    correct_option: 2,
  },
  2: {
    ques: "What is the full form of URL?",
    option1: "Uniform Resource Locator",
    option2: "Universal Resource Link",
    option3: "Universal Read Link",
    option4: "Universal Read Locator",
    correct_option: 1,
  },
  3: {
    ques: "Who is the CEO of Google?",
    option1: "Satya Nadella",
    option2: "Sundar Pichai",
    option3: "Jeff Bezos",
    option4: "Jack Ma",
    correct_option: 2,
  },
  4: {
    ques: "Who was the founder of JAVA?",
    option1: "Mool Chand Ji",
    option2: "Daniel Weber",
    option3: "Guido van Rossum",
    option4: "James Gosling",
    correct_option: 4,
  },
  5: {
    ques: "Which is the hottest Planet?",
    option1: "Venus",
    option2: "Mercury",
    option3: "Mars",
    option4: "Jupitor",
    correct_option: 1,
  },
  6: {
    ques: "Who is the current CEO of Github?",
    option1: "Nat Friedman",
    option2: "Chris Wanstrath",
    option3: "Rajnath Singh",
    option4: "Alison Tyler",
    correct_option: 1,
  },
  7: {
    ques: "Which was the first English news paper of India?",
    option1: "Hindustan Times",
    option2: "Times of India",
    option3: "Hicky's Bengal Gazette",
    option4: "Amar Ujala",
    correct_option: 3,
  },
  8: {
    ques: "Which was the first ever movie released in India?",
    option1: "Mugle Azam",
    option2: "Tere Naam",
    option3: "Angoor",
    option4: "Raja Harishchandra",
    correct_option: 4,
  },
  9: {
    ques: '"East or west Web Developers are the best."',
    option1: "Hell Yes!",
    option2: "I think yes",
    option3: "They are quite good",
    option4: "I am not sure",
    correct_option: 1,
  },
};
